// @ts-nocheck
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  createContactInfoReducer,
  initialState as createContactInfoInitialState,
} from "./reducers/createEvent";
import { authReducer, initialState as authInitialState } from "./reducers/auth";
import {
  dashboardReducer,
  initialState as dashboardInitialState,
} from "./reducers/event/dashboard";
import {
  positionReducer,
  initialState as positionsInitialState,
} from "./reducers/positions";
import {
  contractorReducer,
  initialState as contractorInitialState,
} from "./reducers/contractor";
import {
  contractorSignupReducer,
  initialState as contractorSignupInitialState,
} from "./reducers/contractorSignupReducer";
import adminReducer, {
  initialState as adminInitialState,
} from "./reducers/admin";
import coordinatorReducer, {
  initialState as coordinatorInitialState,
} from "./reducers/coordinator";
import clientReducer, {
  initialState as clientInitialState,
} from "./reducers/client";
import eventRequestReducer, {
  initialState as eventRequestInitialState,
} from "./reducers/eventRequest";
import eventRequestDetailsReducer, {
  initialState as eventRequestDetailsInitialState,
} from "./reducers/eventRequestDetails";
import estimateReducer, {
  initialState as estimateInitialState,
} from "./reducers/estimate";
import approvedEventsReducer, {
  initialState as approvedEventsInitialState,
} from "./reducers/approvedEvents";
import {
  eventFormMetadataReducer,
  initialState as eventFormMetadataInitialState,
} from "./reducers/eventFormMetadataReducer";
import alertDialogReducer, {
  initialState as alertDialogInitialState,
} from "./reducers/alertDialog";
import partialEventsReducer, {
  initialState as partialEventsInitialState,
} from "./reducers/partialRequests";
import logsReducer, { initialState as logsInitialState } from "./reducers/logs";
import reportedIssuesReducer, {
  initialState as reportedIssuesInitialState,
} from "./reducers/reportedIssues";
import contractorScheduleTabReducer, {
  initialState as contractorSchedulesInitialState,
} from "./reducers/contractorScheduleTabReducer";
import opportunitiesReducer, {
  initialState as opportunitiesInitialState,
} from "./reducers/opportunities";
import googleMapsReducer, {
  initialValues as googleMapsPackageInitialState,
} from "./reducers/googleMapsPackageReducer";
import oneononemessaging, {
  initialState as oneOnOneMessagingInitialState,
} from "./reducers/oneononemessaging";
import noteoneononemessaging, {
  initialState as noteOneOnOneMessagingInitialState,
} from "./reducers/noteoneononemessagingReducer";
import groupMessaging, {
  initialState as groupMessagingInitialState,
} from "./reducers/groupMessaging";
import stylingThemes, {
  initialState as stylingThemesInitialState,
} from "./reducers/stylingThemes";
import notifications, {
  initialState as notificationsInitialState,
} from "./reducers/notificationsReducer";
import firebaseReducer, {
  initialState as firebaseInitialState,
} from "./reducers/firebaseReducer";
import {
  deletedUsersReducer,
  initialState as deletedUsersInitialState,
} from "./reducers/deletedUsers";
import { LOGOUT_SUCCESS } from "./constants/auth";
import emailRedirectionReducer, {
  initialState as emailRedirectionInitialState,
} from "./reducers/emailRedirectionReducer";
import estimateData, {
  initialValues as estimateDataInitialState,
} from "./reducers/estimateData";
import prebookReducer from "./reducers/event/prebook";
import manageAirportReducer from "./reducers/config/manageAirport";
import requestedQuoteReducer from "./reducers/config/requestedQuote";
import tutorialVideoReducer, {
  initialState as tutorialVideoConfigurationInitialState,
} from "./reducers/tutorialVideoReducer";
import allContractReducer from "./reducers/contract/contract";
import depositInvoiceReducer, {
  initialState as depositInitialState,
} from "./reducers/depositInvoice/depositInvoice";
import smsReducer, {
  initialState as initialMessageReducer,
} from "./reducers/sms/sms";
import travelDaysReducer, {
  initialState as travelDaysInitialState,
} from "./reducers/position/travelDays";
import freelanceReducer, {
  initialState as freelanceInitialState,
} from "./reducers/user/freelance";
import freelancePositionsReducer, {
  initialState as freelancePositionsInitialState,
} from "./reducers/event/freelancePositions";
import adjustmentsReducer, {
  initialState as adjustmentsInitialState,
} from "./reducers/event/adjustments";
import rateListReducer, {
  initialState as rateListInitialState,
} from "./reducers/config/rateList";
import tableColumnVisibilityReducer, {
  initialState as tableColumnVisibilityInitialState,
} from "./reducers/tableColumnVisibility";
import dashboardFiltersReducer, {
  initialState as dashboardFiltersInitialState,
} from "./reducers/dashboardFiltersReducer";
import contractorLinkReducer, {
  initialState as contractorLinkInitialState,
} from "./reducers/config/contractorLink";
import systemNotificationsReducer, {
  initialState as systemNotificationsInitialState,
} from "./reducers/config/systemNotifications";
import reportFiltersReducer, {
  initialState as reportFiltersInitialState,
} from "./reducers/reportFiltersReducer";
import contractorRatingsReducer, {
  initialState as contractorRatingsInitialState,
} from "./reducers/contractorRatings";
import contractorShowsReducer, {
  initialState as contractorShowsInitialState,
} from "./reducers/contractorShows";
import surveysReducer, {
  initialState as surveysInitialState,
} from "./reducers/surveys";

// import reimbursementReducer from "./reducers/schedule";
// import scheduleReducer from "./reducers/schedule";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "eventForm",
    "emailRedirection",
    "googleMapsPackage",
    "contract",
    "rateList",
    // R02 fix: the /reports/contractor-work filters must not reset when
    // navigating away and back. Persisted to localStorage to survive
    // a refresh as well (hot-fix of the hot-fix).
    "reportFilters",
    // Column visibility per table (Dashboard, Revenue, etc.).
    // Without persist it disappeared on refresh. With persist + local-state
    // sync from Dashboard.tsx on mount, it survives both navigation AND refresh.
    "tableColumnVisibility",
  ],
};

const appReducer = combineReducers({
  createContactInfo: createContactInfoReducer,
  auth: authReducer,
  positions: positionReducer,
  // sessionPositions: sessionPositionsReducer,
  contractor: contractorReducer,
  freelance: freelanceReducer,
  freelancePositions: freelancePositionsReducer,
  adjustmentsReducer: adjustmentsReducer,
  admin: adminReducer,
  coordinator: coordinatorReducer,
  client: clientReducer,
  eventForm: eventFormMetadataReducer,
  eventRequest: eventRequestReducer,
  dashboard: dashboardReducer,
  eventRequestDetails: eventRequestDetailsReducer,
  estimate: estimateReducer,
  estimateData: estimateData,
  prebookContractors: prebookReducer,
  approvedEvent: approvedEventsReducer,
  alertDialog: alertDialogReducer,
  partialRequest: partialEventsReducer,
  logs: logsReducer,
  reportedIssues: reportedIssuesReducer,
  contract: allContractReducer,
  depositInvoice: depositInvoiceReducer,
  smsReducer: smsReducer,
  travelDays: travelDaysReducer,

  // requested quote
  requestedQuote: requestedQuoteReducer,

  // airport
  airport: manageAirportReducer,

  // rate list
  rateList: rateListReducer,

  // contractor links
  contractorLink: contractorLinkReducer,

  // system notifications
  systemNotifications: systemNotificationsReducer,

  // notification reducers...
  notifications,
  // notification reducers...

  // contractor reducers...
  contractorSignup: contractorSignupReducer,
  contractorSchedules: contractorScheduleTabReducer,
  opportunities: opportunitiesReducer,
  // schedule: scheduleReducer,
  // reimburesement: reimbursementReducer,

  // messaging reducers start...
  oneOnOneMessaging: oneononemessaging,
  groupMessaging,

  noteOneOnOneMessaging: noteoneononemessaging,
  // messaging reducers end...

  // google maps package reducers...
  googleMapsPackage: googleMapsReducer,

  // firebase reducers...
  firebase: firebaseReducer,

  //deletedUsers reducers
  deletedUsers: deletedUsersReducer,

  // styling theme reducers...
  stylingThemes,

  // email redirection reducers...
  emailRedirection: emailRedirectionReducer,
  tutorialVideoConfiguration: tutorialVideoReducer,

  // table column visibility reducers...
  tableColumnVisibility: tableColumnVisibilityReducer,

  // dashboard filters reducers...
  dashboardFilters: dashboardFiltersReducer,

  // report-page filters (R02 fix) — preserves date range, contractor, state,
  // event across navigations within /reports/*
  reportFilters: reportFiltersReducer,

  // internal rating do contractor (admin/coord/superAdmin only)
  contractorRatings: contractorRatingsReducer,

  // shows trabalhados por contractor, cache do card de contato (admin/superAdmin only)
  contractorShows: contractorShowsReducer,

  // satisfaction survey config (admin/superAdmin only)
  surveys: surveysReducer,
});

// This function acts as an interceptor and can be used to send data to the reducer.
const rootReducer = (state, action) => {
  // If the passed action's type is "LOGOUT_SUCCESS", then, we remove the persisted data from localStorage,
  // and then pass undefined to all the reducers to reset the redux store...
  if (action?.type === LOGOUT_SUCCESS) {
    const allReducers = [
      "createContactInfo",
      "auth",
      "positions",
      "contractor",
      "admin",
      "coordinator",
      "client",
      "eventForm",
      "eventRequest",
      "eventRequestDetails",
      "estimate",
      "estimateData",
      "approvedEvent",
      "alertDialog",
      "partialRequest",
      "logs",
      "reportedIssues",
      "notifications",
      "contractorSignup",
      "contractorSchedules",
      "opportunities",
      "oneOnOneMessaging",
      "groupMessaging",
      "googleMapsPackage",
      "firebase",
      "deletedUsers",
      "stylingThemes",
      "emailRedirection",
      "tutorialVideoConfiguration",
      "dashboard",
      "dashboardReducer",
      "depositInvoice",
      "smsReducer",
      "rateList",
      "tableColumnVisibility",
      "dashboardFilters",
      "systemNotifications",
      "reportFilters",
      "contractorRatings",
      "contractorShows",
      "surveys",
    ];

    const whitelistedReducers = {};
    const blacklistedReducers = {};
    const allReducersInitialState = {
      createContactInfo: createContactInfoInitialState,
      auth: authInitialState,
      positions: positionsInitialState,
      contractor: contractorInitialState,
      freelance: freelanceInitialState,
      freelancePositions: freelancePositionsInitialState,
      adjustmentsReducer: adjustmentsInitialState,
      admin: adminInitialState,
      coordinator: coordinatorInitialState,
      client: clientInitialState,
      eventForm: eventFormMetadataInitialState,
      eventRequest: eventRequestInitialState,
      eventRequestDetails: eventRequestDetailsInitialState,
      estimate: estimateInitialState,
      estimateData: estimateDataInitialState,
      approvedEvent: approvedEventsInitialState,
      alertDialog: alertDialogInitialState,
      partialRequest: partialEventsInitialState,
      logs: logsInitialState,
      reportedIssues: reportedIssuesInitialState,
      notifications: notificationsInitialState,
      contractorSignup: contractorSignupInitialState,
      contractorSchedules: contractorSchedulesInitialState,
      opportunities: opportunitiesInitialState,
      oneOnOneMessaging: oneOnOneMessagingInitialState,
      groupMessaging: groupMessagingInitialState,
      noteOneOnOneMessaging: noteOneOnOneMessagingInitialState,
      googleMapsPackage: googleMapsPackageInitialState,
      firebase: firebaseInitialState,
      deletedUsers: deletedUsersInitialState,
      stylingThemes: stylingThemesInitialState,
      emailRedirection: emailRedirectionInitialState,
      tutorialVideoConfiguration: tutorialVideoConfigurationInitialState,
      rateList: rateListInitialState,
      contractorLink: contractorLinkInitialState,
      dashboard: dashboardInitialState,
      depositInvoice: depositInitialState,
      smsReducer: initialMessageReducer,
      travelDays: travelDaysInitialState,
      tableColumnVisibility: tableColumnVisibilityInitialState,
      dashboardFilters: dashboardFiltersInitialState,
      systemNotifications: systemNotificationsInitialState,
      reportFilters: reportFiltersInitialState,
      contractorRatings: contractorRatingsInitialState,
      contractorShows: contractorShowsInitialState,
      surveys: surveysInitialState,
    };

    for (let i = 0; i < action?.payload?.whitelistedReducers?.length; i++) {
      whitelistedReducers[action?.payload?.whitelistedReducers?.[i]] =
        state?.[action?.payload?.whitelistedReducers?.[i]];
    }

    for (let i = 0; i < allReducers?.length; i++) {
      if (!(allReducers[i] in whitelistedReducers)) {
        blacklistedReducers[allReducers[i]] =
          allReducersInitialState[allReducers[i]];
      }
    }

    storage.removeItem("persist:root");
    // return appReducer(undefined, action);
    return appReducer(
      {
        ...whitelistedReducers,
        ...blacklistedReducers,
      },
      action,
    );
  } else {
    return appReducer(state, action);
  }
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;